/* eslint-disable no-console */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import './styles.css';

import NavBar from '../../components/NavBar';
import Load from '../../components/Load';

import { getToken } from '../../api/auth';
import calendarUSAMask from '../../utils/masks/calendarUSAMask';

import { CleaningByIdFetch } from '../../api/services/NotebookAPI';

export default function CleaningDetail({ history }) {
  const token = getToken();
  const [cleaning, setCleaning] = useState(null);
  const [messageWarning, setMessageWarning] = useState('');
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [isLoad, setIsLoad] = useState(false);

  const { cleaningId } = useParams();

  async function getCleaningById() {
    setIsLoad(true);
    try {
      const resultCleaningById = await CleaningByIdFetch(token, cleaningId);
      console.log('getCleaningById | resultCleaningById: ', resultCleaningById);
      setIsLoad(false);
      setMessageWarning(resultCleaningById.message);
      setIsSuccessMessage(resultCleaningById.isSuccess);
      setCleaning(resultCleaningById.cleaningDetail);
    } catch (error) {
      console.log('getCleaningById | error: ', error);
      setIsSuccessMessage(false);
      setMessageWarning('No momento esse recurso está indisponível, tente novamente mais tarde.');
      setIsLoad(false);
    }
  }

  useEffect(() => {
    getCleaningById();
  }, [history, token]);

  return (
    <>
      <Load isShow={isLoad} />
      <NavBar navigation={history} />
      <div className="container__above_header">
        <div className="form">
          <p className="form__description">
            Detalhes da Limpeza
          </p>

          {messageWarning && <p className={isSuccessMessage ? 'form__message form__message--success' : 'form__message form__message--error'}>{messageWarning}</p>}

          {cleaning !== null
            ? (
              <div className="detail__container">
                <p className="detail__label">
                  Item / Área Higienizada
                </p>
                <p className="detail__value">
                  {cleaning.sanitized_item}
                </p>

                <p className="detail__label">
                  Tipo de Limpeza
                </p>
                <p className="detail__value">
                  {cleaning.type}
                </p>

                <p className="detail__label">
                  Nome do Responsável
                </p>
                <p className="detail__value">
                  {cleaning.name_responsible}
                </p>

                <p className="detail__label">
                  Nome do Verificador
                </p>
                <p className="detail__value">
                  {cleaning.name_checker}
                </p>

                <p className="detail__label">
                  Observação
                </p>
                <p className="detail__value">
                  {cleaning.observation}
                </p>

                <p className="detail__label">
                  Criado Em
                </p>
                <p className="detail__value">
                  {calendarUSAMask(cleaning.created)}
                </p>
              </div>
            ) : null }
        </div>
      </div>
    </>
  );
}
